import React, { useState, useEffect } from "react";

const Drawer = ({ isOpen, onClose, children, position = "right", width = "w-80" }) => {
  // Đóng drawer khi nhấn ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed z-50 inset-0 bg-black bg-opacity-30 transition-opacity ${
          isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        onClick={onClose}
      ></div>

      {/* Drawer */}
      <div
        className={`fixed  z-50 top-0 ${position}-0 h-full bg-white shadow-lg transform transition-transform duration-300  ${
          isOpen ? "translate-x-0" : position === "right" ? "translate-x-full" : "-translate-x-full"
        } ${width} `}
      >
        {children}
      </div>
    </>
  );
};

export default Drawer;
